/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Ответ с количеством успешно подтверждённых команд
 * @export
 * @interface FxIdWebFeaturesClientCommandsAckResponse
 */
export interface FxIdWebFeaturesClientCommandsAckResponse {
    /**
     * Количество подтверждённых команд (lease_token совпал и команда ещё не acked)
     * @type {number}
     * @memberof FxIdWebFeaturesClientCommandsAckResponse
     */
    AcknowledgedCount: number;
}

/**
 * Check if a given object implements the FxIdWebFeaturesClientCommandsAckResponse interface.
 */
export function instanceOfFxIdWebFeaturesClientCommandsAckResponse(value: object): value is FxIdWebFeaturesClientCommandsAckResponse {
    if (!('AcknowledgedCount' in value) || value['AcknowledgedCount'] === undefined) return false;
    return true;
}

export function FxIdWebFeaturesClientCommandsAckResponseFromJSON(json: any): FxIdWebFeaturesClientCommandsAckResponse {
    return FxIdWebFeaturesClientCommandsAckResponseFromJSONTyped(json, false);
}

export function FxIdWebFeaturesClientCommandsAckResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesClientCommandsAckResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'AcknowledgedCount': json['AcknowledgedCount'],
    };
}

export function FxIdWebFeaturesClientCommandsAckResponseToJSON(json: any): FxIdWebFeaturesClientCommandsAckResponse {
    return FxIdWebFeaturesClientCommandsAckResponseToJSONTyped(json, false);
}

export function FxIdWebFeaturesClientCommandsAckResponseToJSONTyped(value?: FxIdWebFeaturesClientCommandsAckResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'AcknowledgedCount': value['AcknowledgedCount'],
    };
}

